import { BoardingClassStudent } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    //
    impItems: [],
  },
  actions: {
    async fetchItems({ commit }, params) {
      const items = await BoardingClassStudent.fetch(params)
      commit('changeState', { items })
    },
    updateByExcel(_, { id, ...params }) {
      return BoardingClassStudent.updateByExcel(id, params)
    },
    addMany(_, { id, ...params }) {
      return BoardingClassStudent.addMany(id, params)
    },
    removeSingle(_, { id, ...params }) {
      return BoardingClassStudent.removeSingle(id, params)
    },
  },
  mutations: {
    setImportedItems: (state, items) => (state.impItems = items),
  },
  getters: {
    items: state => state.items
  },
}
